import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh-CN'
import zhTW from './zh-TW'
import en from './en'
// 注册插件
Vue.use(VueI18n)

// 实例化 i18n
const i18n = new VueI18n({
    locale: 'zh-CN', // 默认语言
    fallbackLocale: 'zh-CN', // 语言切换失败时的 fallback
    messages: {
        'zh-CN': zhCN,
        'zh-TW': zhTW,
        'en': en
    }
    
})

export default i18n
